import {isAdmin} from 'lib/user'

import {safeFetch, SafeResponse} from './safe-fetch'

const defaultJsonParser = (res: Response) => res.json()

export function createAuthHeaders(user?: CL.User) {
  const headers: HeadersInit = {
    Authorization: `bearer ${user?.idToken}`
  }

  // Add the admin access group for administrators if it exists.
  if (isAdmin(user)) {
    const adminTempAccessGroup = window.__user?.adminTempAccessGroup ?? ''
    if (adminTempAccessGroup?.length > 0) {
      headers['X-Conveyal-Access-Group'] = adminTempAccessGroup
    }
  }
  return headers
}

/**
 * Fetch wrapper that includes authentication in the `Authorization` header. Defaults request /
 * response content type to JSON. This is necessary to use when communicating over the Java API but
 * not with the Lambda API. Cookies cannot be used in CORS.
 */
export default function authFetch<T>(
  url: string,
  user: CL.User,
  config?: {
    parser?: (res: Response) => Promise<T>
    options?: RequestInit
  }
): Promise<SafeResponse<T>> {
  return safeFetch<T>(url, config?.parser ?? defaultJsonParser, {
    mode: 'cors',
    ...(config?.options ?? {}),
    headers: {
      ...createAuthHeaders(user),
      ...(config?.options?.headers ?? {})
    }
  })
}
